import { db } from '@/main'
import { doc, writeBatch, arrayRemove, updateDoc, deleteDoc } from "firebase/firestore";
import { getAuth } from 'firebase/auth'
import helpers from '../../helpers';

export default {
  name: 'guests',
  components: {},
  props: [],
  data () {
    return {
      openTab: 1,
      invites: "",
      guests: [],
      view: {
        loadingGuests: true
      }
    }
  },
  computed: {
    boundGuests () {
      return this.$store.state.users.boundDirectory
    },
    org () {
      return this.$store.getters.activeOrg
    },
    guestInvites () {
      return this.$store.getters.guestInvites
    },
    user () {
      return this.$store.getters.userData
    },
  },
  mounted () {
    this.getEmails();
    if(this.$route.query && this.$route.query.t){
      this.openTab = parseFloat(this.$route.query.t)
    }
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.$router.push({query: {t: tabNumber}})
      this.openTab = tabNumber
    },
    async getEmails () {

      // let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)

      const auth = getAuth();
      const user = auth.currentUser;
      let token = await user.getIdToken(user, true)

      let obj = {
        token: token, 
        org: this.org.id,
        userType: "guests",
        cursor: 0
      }
      // console.log('obj to post:', obj);

      let res = await fetch('/api/orgemails', {
        method: 'post',
        body: JSON.stringify(obj),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })

      res = await res.json();

      if(!res.error){
        // console.log('res:', res);
        // remove this users's email from the guests array
        this.guests = res.data.filter(guest => guest.email !== this.user.email)
        this.view.loadingGuests = false;
      } else {
        console.log("error getting emails:", res.message)
        this.$toast.error("Error: "+res.message);
      }

    },
    async inviteUsers() {

      console.log('inviting users:', this.invites)
      let separated = this.invites.trim().split(",")
      separated = this.invites.trim().split(`\n`)

      let trimmed = separated.map(el => {
        return el.trim()
      })

      // filter out invalid addresses
      trimmed = trimmed.filter(email => {
        return validateEmail(email)
      })
      console.log('trimmed:', trimmed);

      if(!trimmed.length) return console.log("no emails")
      
      try {
        
        const batch = writeBatch(db);
        
        trimmed.forEach(email => {
          // create a doc in the invites subcollection for the org
          let invitesRef = doc(db, "orgs", this.org.id, "guestInvites", helpers.generateID());

          let data = {
            invitedDate: new Date(),
            email: email,
            orgName: this.org.name,
            orgId: this.org.id,
            inviter: this.user.id
          }

          batch.set(invitesRef, data);

        })

        await batch.commit()
        
        this.$toast.success("Invites sent!");

        this.invites = ""

        this.$store.dispatch("getGuestInvites");

      } catch (error) {
        console.log('error writing batch invites:', error);
        this.$toast.error("Something went wrong!");
      }
      
    },
    async deleteInvite(invite){
      try {

        let docRef = doc(db, "orgs", this.org.id, "guestInvites", invite.id);

        await deleteDoc(docRef)

        // update the store with the new resources array
        this.$store.dispatch("getGuestInvites");

        this.$toast.success("Invite deleted");

      } catch (error) {
        console.log("error deleting resource:", error)
      }
    },
    async deleteGuest(guest){
      try {

        // remove this guest.id from guests array on the org
        console.log('user wants to remove guest:', guest);

        let docRef = doc(db, "orgs", this.org.id);

        await updateDoc(docRef, {
          "guests": arrayRemove(guest.id)
        })

        // update the store with the new resources array
        
        this.guests = this.guests.filter(guestObj => guestObj.id !== guest.id )

        this.$toast.success("Guest removed");

      } catch (error) {
        console.log("error deleting resource:", error)
      }
    }
  }
}

function validateEmail(email) {
  // eslint-disable-next-line
  const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return res.test(String(email).toLowerCase());
}